module.exports = __webpack_public_path__ + "static/map-bg-bb1c4c059368d920d16dd92d9d617e42.png";